import React from "react";
export const DivCell = React.memo(({children, className}) => {
    return (
        <div className={`${className} mr-1 px-1`}>
            {children}
        </div>
    );
});